// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"ManageAdmins_overlayWrapper__edO4i","viewBox":"ManageAdmins_viewBox__vUvcp","tablestyle":"ManageAdmins_tablestyle__h-0fj"};